/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";

const MetricRow = ({ label, count, percentage, color }) => (
  <div className="flex items-center justify-between py-2 px-3 hover:bg-slate-800/50 rounded-xl transition-colors">
    <div className="flex items-center gap-2 sm:gap-3">
      <div className={`w-1.5 h-1.5 rounded-full ${color}`}></div>
      <span className="text-xs sm:text-sm font-medium text-white/70 truncate">
        {label}
      </span>
    </div>
    <div className="flex items-center gap-2 sm:gap-4">
      <span className="font-bold text-white text-sm sm:text-base">{count}</span>
      <span className="text-xs text-white/60 bg-slate-700 px-1.5 py-0.5 rounded-md">
        {percentage}
      </span>
    </div>
  </div>
);

export default MetricRow;
